import { render, staticRenderFns } from "./ServiceOrderingChannels.vue?vue&type=template&id=1b7252ea&scoped=true&"
import script from "./ServiceOrderingChannels.vue?vue&type=script&lang=js&"
export * from "./ServiceOrderingChannels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7252ea",
  null
  
)

export default component.exports